export default __webpack_public_path__ + "static/media/default-user-image1.619cc907.png";